import React from "react";
import { LinearGradient } from 'expo-linear-gradient'
import isEqual from 'react-fast-compare'
import { linearGradientBackgroundStyles } from 'styles/components/atoms/LinearGradientBackground'

export const LinearGradientBackgroundColors = {
	LIGHT: 'white',
	DARK: 'dark'
};

export const LinearGradientBackgroundPatterns = {
	TOP_TO_BOTTOM : 'top_to_bottom',
	BOTTOM_TO_TOP : 'bottom_to_top',
	CENTERED: 'centered'
}

const LinearGradientBackground = ( { color = LinearGradientBackgroundColors.LIGHT, pattern = LinearGradientBackgroundPatterns.TOP_TO_BOTTOM, maxOpacity = 0.3, minOpacity = 0 }) => {

	let colors = [];
	let r = 0;
	let g = 0;
	let b = 0;

	switch( color ){
		case LinearGradientBackgroundColors.LIGHT:
			r = g = b = 255;
            break;
        case LinearGradientBackgroundColors.DARK:
	        r = g = b = 0;
	        break;
	}
	
	switch( pattern ){
		case LinearGradientBackgroundPatterns.TOP_TO_BOTTOM:
			colors = [ `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${minOpacity} )`];
			break;
			
		case LinearGradientBackgroundPatterns.BOTTOM_TO_TOP:
			colors = [ `rgba( ${r}, ${g}, ${b}, ${minOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`];
			break;
			
		case LinearGradientBackgroundPatterns.CENTERED:
			colors = [ `rgba( ${r}, ${g}, ${b}, ${minOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${maxOpacity} )`, `rgba( ${r}, ${g}, ${b}, ${minOpacity} )`];
			break;
	}
	
	return (
		<LinearGradient
			colors={ colors }
			style={ linearGradientBackgroundStyles.container }
		/>
	);
}

export default React.memo( LinearGradientBackground, isEqual );
